<template>
  <div>
      <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',

  components: {
  },
  mounted() {
    document.title = 'Enhancefeed'
  },

  data: () => ({
       
  }),
};
</script>

<style lang="scss">
    body {
        font-family: 'Roboto', sans-serif;
    }
</style>
